import api from '../services/api'

export default async function (file) {
  const data = new FormData()
  data.append('file', file[0] || file)
  const res = await api.post('/upload', data)

  return res
}
